(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/models/single-search-result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/models/single-search-result.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.models.SingleSearchResult = Backbone.Model.extend({});
})(Backbone, _, svs);


 })(window);